import { useNavigate } from 'react-router-dom';

import { useRoutingFunction, useIsRouteFunction } from '@/store/routingStore';

export const useCustomNavigate = () => {
  const routerNavigate = useNavigate();
  const routingFunction = useRoutingFunction();
  const isRouteFunction = useIsRouteFunction();

  return (path: string) => {
    if (isRouteFunction && routingFunction) {
      const routeFunc = () => {
        routerNavigate(path);
      };
      routingFunction(routeFunc);
    } else {
      routerNavigate(path);
    }
  };
};
